import { GQLProductFragment } from '@theprintbar/graphql';
import { cn, hasRichText } from '@theprintbar/shared';
import { OutlineLinkButton, RichText } from '../..';

interface CalloutBarProps {
	product: GQLProductFragment;
	className?: string;
}

export function CalloutBar({ product, className }: CalloutBarProps) {
	return !!hasRichText(product.designCallout) ? (
		<div className={cn('flex border px-4 py-3 border-blue items-center justify-between rounded-3xl bg-orange/30', className)}>
			<div className="text-xs">
				<RichText content={product.designCallout} />
			</div>
			{!!product.designCalloutLink.structure?.to && (
				<OutlineLinkButton className="px-4 py-3" to={product.designCalloutLink.structure?.to}>
					{product.designCalloutLink.structure?.to || 'Learn More'}
				</OutlineLinkButton>
			)}
		</div>
	) : null;
}
